import React from "react";
import CatalogItemsPage from "./CatalogItemsPage";
import olreadiaService from "services/olreadiaService";

export default function ProfessionalSpecializationsPage() {
  return (
    <CatalogItemsPage
      title="Specializations"
      subtitle="Create and manage professional specializations used by job opportunities."
      icon="star"
      newLabel="New Specialization"
      itemLabel="Specialization"
      showDelete={false}
      codeReadOnly
      loadItems={() => olreadiaService.professionalSpecializations.list()}
      getItem={(record) => olreadiaService.professionalSpecializations.get(record.id)}
      createItem={(payload) => olreadiaService.professionalSpecializations.create(payload)}
      updateItem={(record, payload) =>
        olreadiaService.professionalSpecializations.update(record.code, payload)
      }
      normalizeSearch={(item) => `${item?.code || ""} ${item?.name || ""} ${item?.description || ""}`}
    />
  );
}

